<template>
    <b-row class="mt-2 composition">
        <b-col class="table-responsive"
               v-if="product.raw_materials.length > 0"
        >
            <table class="table">
                <thead>
                <tr>
                    <th class="align-middle">
                        Materia prima
                    </th>
                    <th style="width: 140px; max-width: 140px;"
                        class="text-center align-middle"
                    >
                        % Usado en la preparación
                    </th>
                    <th class="align-middle">
                        Componentes
                    </th>
                    <th style="width: 140px; max-width: 140px;"
                        class="text-center align-middle"
                    >
                        % Máx reportado en FDS de la materia prima
                    </th>
                    <th style="width: 100px; max-width: 100px;"
                        class="text-center align-middle"
                    >
                        % Final en la mezcla
                    </th>
                    <th class="align-middle"
                        style="min-width: 220px"
                    >
                        SGA
                    </th>
                    <th width="100px"
                        class="text-center align-middle"
                        v-if="!only_view"
                    >
                    </th>
                </tr>
                </thead>
                <tbody v-for="(rm, irm) in product.raw_materials"
                          v-if="rm.name.trim().toLowerCase().includes(name.trim().toLowerCase())"
                          v-bind:class="{'table-selected': irm % 2 === 0, 'table-white': irm % 2 === 1}"
                >
                    <tr v-for="(c, i) in rm.components.filter(comp => !comp.omit_in_composition)">
                        <td v-if="i === 0"
                            :rowspan="rm.components.filter(comp => !comp.omit_in_composition).length"
                        >
                            {{ rm.name }}
                        </td>
                        <td v-if="i === 0"
                            :rowspan="rm.components.filter(comp => !comp.omit_in_composition).length"
                            class="text-center"
                        >
                            <input_formatter v-model="rm.percentage"
                                             symbol="%"
                                             :position_symbol="false"
                                             :decimals="4"
                                             input_class="text-center"
                                             @changeInput="changePercentage(rm)"
                                             v-if="!only_view"
                            />
                            <div v-else>
                                {{ rm.percentage }}%
                            </div>
                        </td>
                        <td>{{ c.cas_number }} - {{ c.name }}</td>
                        <td class="text-center">
                            <input_formatter v-model="c.reported_percentage"
                                             symbol="%"
                                             :position_symbol="false"
                                             :decimals="4"
                                             input_class="text-center"
                                             @changeInput="changeReportedPercentage(rm, c)"
                                             v-if="!only_view"
                            />
                            <div v-else>
                                {{ c.reported_percentage }}%
                            </div>
                        </td>
                        <td class="text-center">
                            <div class="text-center pr-2 mt-1"
                                 style="color: rgb(96, 98, 102);"
                            >
                                {{ c.final_percentage }}%
                            </div>
                            <el-progress :percentage="c.final_percentage"
                                         :stroke-width="10"
                                         color="#4dbd74"
                                         :show-text="false"
                            />
                        </td>
                        <td v-if="c.sga_categories.length">
                            <div v-for="s in c.sga_categories">
                                <b-badge variant="primary"
                                         style="width: 40px"
                                         class="mr-1"
                                >
                                    {{ s.category.codigo }}
                                </b-badge>
                                {{ s.category.categoria }}
                            </div>
                        </td>
                        <td v-else>
                            NO REPORTADO
                        </td>
                        <td v-if="i === 0 && !only_view"
                            :rowspan="rm.components.filter(comp => !comp.omit_in_composition).length"
                        >
                            <el-tooltip effect="dark"
                                        placement="top"
                                        content="Eliminar"
                                        popper-class="py-1 px-2"
                            >
                                <b-button variant="outline-danger"
                                          class="float-right mr-1"
                                          size="sm"
                                          @click="_deleteRawMaterial(rm)"
                                >
                                    <i class="fa fa-trash"/>
                                </b-button>
                            </el-tooltip>

                            <el-tooltip effect="dark"
                                        placement="top"
                                        content="Editar"
                                        popper-class="py-1 px-2"
                            >
                                <b-button variant="outline-primary"
                                          class="float-right mr-1"
                                          size="sm"
                                          @click="openModalForEdition(rm)"
                                >
                                    <i class="fa fa-edit"/>
                                </b-button>
                            </el-tooltip>
                        </td>
                    </tr>

                    <tr v-if="!rm.components.filter(comp => !comp.omit_in_composition).length">
                        <td>{{ rm.name }}</td>
                        <td class="text-center">{{ rm.percentage }}%</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td v-if="!only_view" class="text-nowrap">
                            <el-tooltip effect="dark"
                                        placement="top"
                                        content="Eliminar"
                                        popper-class="py-1 px-2"
                            >
                                <b-button variant="outline-danger"
                                          class="float-right mr-1"
                                          size="sm"
                                          @click="_deleteRawMaterial(rm)"
                                >
                                    <i class="fa fa-trash"/>
                                </b-button>
                            </el-tooltip>

                            <el-tooltip effect="dark"
                                        placement="top"
                                        content="Editar"
                                        popper-class="py-1 px-2"
                            >
                                <b-button variant="outline-primary"
                                          class="float-right mr-1"
                                          size="sm"
                                          @click="openModalForEdition(rm)"
                                >
                                    <i class="fa fa-edit"/>
                                </b-button>
                            </el-tooltip>
                        </td>
                    </tr>
                </tbody>
            </table>
            <b-card class="mt-2 mb-0 border-card-warning"
                    body-class="p-3"
            >
                <h5 class="font-weight-bold mb-0">
                    Total: {{ product.total_percentage }}%
                </h5>
            </b-card>
        </b-col>

        <b-col v-else>
            <b-card class="mt-2 mb-0"
                    body-class="p-3 text-center"
            >
                <h6 class="text-muted my-4 ">
                    No hay materias primas para mostrar
                </h6>
                <b-button variant="primary"
                          size="sm"
                          @click="$emit('create')"
                >
                    <i class="fa fa-plus"/> Agregar
                </b-button>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import component from './component';
import new_component from './new_component';
import wizard from './wizard.vue';
import input_formatter from '../../components/input_formatter';

export default {
    name: 'index',
    props: {
        name: {
            required: false,
            default: '',
            type: String
        }
    },
    components: {
        wizard,
        component,
        new_component,
        input_formatter
    },
    data() {
        return {
            columns: [
                {
                    key: 'name',
                    label: 'Nombre'
                },
                {
                    key: 'percentage',
                    label: '% usado en la preparación'
                },
                {
                    key: 'components',
                    label: 'Componentes'
                },
                {
                    key: 'actions',
                    label: ''
                }
            ]
        };
    },
    computed: {
        ...mapState('calculator', [
            'product',
            'raw_material',
            'modal_components',
            'modal_wizard',
            'only_view'
        ])
    },
    methods: {
        ...mapActions('calculator', [
            'deleteRawMaterial',
            'updateRawMaterial',
            'getProduct',
            'updateComponents',
            'downloadComposition',
            'getRawMaterial',
            'getRawMaterial',
            'createRawMaterial'
        ]),
        ...mapMutations('calculator', [
            'setModalRawMaterialShow',
            'setActionRawMaterialShow',
            'setRawMaterial',
            'setModalComponentsShow',
            'setShowToModalWizard',
            'setStepToModalWizard',
            'resetRawMaterial',
            'setActionToModalRawMaterial',
            'setShowToModalRawMaterial'
        ]),
        async openModalForEdition(raw_material) {
            this.setActionToModalRawMaterial('u');
            await this.getRawMaterial(raw_material);
            this.setShowToModalRawMaterial(true);
        },
        async _deleteRawMaterial(rm) {
            await this.deleteRawMaterial(rm);

            await this.getProduct({
                product_id: this.product.id,
                company_id: this.product.slq_company_id
            });
        },
        async changePercentage(rm) {
            let reg = new RegExp('^(\\d{0,2}(\\.\\d{1,2})?|100(\\.00?)?)$');

            if (reg.test(rm.percentage.toString())) {
                this.setActionToModalRawMaterial('u');
                this.setRawMaterial(rm)
                await this.updateRawMaterial();

                const product_id = this.$route.params.product_id;
                const company_id = this.$route.params.company_id;

                if (!!product_id && !!company_id) {
                    await this.getProduct({product_id, company_id});
                }
            }
        },
        async changeReportedPercentage(rm, c) {
            let reg = new RegExp('^(\\d{0,2}(\\.\\d{1,2})?|100(\\.00?)?)$');

            if (reg.test(c.reported_percentage.toString())) {
                this.setActionToModalRawMaterial('u');
                this.setRawMaterial(rm)
                await this.updateRawMaterial();

                const product_id = this.$route.params.product_id;
                const company_id = this.$route.params.company_id;

                if (!!product_id && !!company_id) {
                    await this.getProduct({product_id, company_id});
                }
            }
        }
    }
};
</script>

<style lang="scss">
.composition {
    .table {
        border-collapse: separate;
        border-spacing: 0;
    }

    .table thead tr:first-child th:first-child {
        border-top-left-radius: 0.3rem;
    }

    .table thead tr:first-child th:last-child {
        border-top-right-radius: 0.3rem;
    }

    .table td,
    .table th {
        padding-top: 0.4rem;
        padding-bottom: 0.4rem;
    }

    .table-selected {
        background-color: #f5f5f5;
        transition: 0.2s;
    }

    .table-white {
        background-color: #ffffff;
        transition: 0.2s;
    }

    .table-selected:hover, .table-white:hover {
        background-color: #dddddd;
    }

    .table-selected .table th, .table-selected .table td {

    }
}
</style>
